import { render, staticRenderFns } from "./Auction.vue?vue&type=template&id=0604ac22&scoped=true&"
import script from "./Auction.vue?vue&type=script&lang=js&"
export * from "./Auction.vue?vue&type=script&lang=js&"
import style0 from "./Auction.vue?vue&type=style&index=0&id=0604ac22&lang=scss&scoped=true&"
import style1 from "./Auction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0604ac22",
  null
  
)

export default component.exports